import IServerOperation from './interface/IServerOperation'
import Intersect from './Intersect'
import Union from './Union'
import Erase from './Erase'

/**
 * 交集取反
 */
export default class SymDiff extends IServerOperation {
    constructor(serviceUrl, proxyUrl) {
        super('symmetricaldifference', serviceUrl, proxyUrl)

        // wps 服务类型
        if (this._type === 'WPS') {
            this._union = new Union(serviceUrl, proxyUrl)
            this._intersect = new Intersect(serviceUrl, proxyUrl)
            this._erase = new Erase(serviceUrl, proxyUrl)
        }
    }
    async process(fc1, fc2, opt_options) {
        if (this._type === 'SAS') {
            return super.process(fc1, fc2, opt_options)
        } else {
            const [ufc, ifc] = await Promise.all([
                this._union.process(fc1, fc2, opt_options),
                this._intersect.process(fc1, fc2, opt_options)
            ])
            return this._erase.process(ufc, ifc, opt_options)
        }
    }
}
